import Current from '../lib/Current';

export default function v1HeaderCurrent() {
  /**
   * グローバルナビゲーションにカレントを出力する
   */
  const mainLinks = ['.v1-headerMainNav__link'];
  const subLinks = ['.v1-headerInterests__link', '.v1-headerDestinations_prefecture'];

  mainLinks.forEach(link => {
    const current = new Current({
      selector: link,
      level: 4,
    });
    current.init();
  });

  subLinks.forEach(link => {
    const current = new Current({
      selector: link,
      level: 5,
    });
    current.init();
  });
}
